import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';

const tcIndexes = ( 
    state = { 
        items: [],
        isLoaded: false,
        pageInfo: {
            count: 0,
        },
    }, 
    action
) => {
    switch (action.type) {
        case actionTypes.GET_TC_INDEXES.REQUEST:
            return {
                ...state,
                items: [],
                isLoaded: false,
            };
        case actionTypes.GET_TC_INDEXES.SUCCESS:
            const items = action.data.data.docs.map(item => {
                return {
                    ...item,
                };
            });

            const pageInfo = action.data.data.pageInfo[0];

            return {
                ...state,
                isLoaded: true,
                items,
                pageInfo,
            };

        case actionTypes.GET_TC_INDEXES.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        default: {
            return state;
        }
    }
}

export default tcIndexes;


// WEBPACK FOOTER //
// ./app/reducers/tc/indexes.js